const extractNumbers = (code) => {
	// Remove the initials from the code (get only digits)
	return code.replace(/\D/g, '');
};

export { extractNumbers };
